<template>
  <div v-loading.fullscreen.lock="fullScreenLoading">
    <div
      class="desktop-menu hidden-md-and-down"
    >
      <Navigation
        :is-admin="isAdmin"
        :is-business="isBusiness"
        :is-team-resp="isTeamResp"
        :is-employee="isEmployee"
        :has-iban="hasIban"
        :sign-out-dialog.sync="signOutDialogVisible"
        :delete-user-dialog.sync="deleteUserDialogVisible"
        :loader-visible.sync="fullScreenLoading"
        :employee-reconciliation-dialog.sync="employeeReconciliationDialog"
      />
    </div>
    <div
      class="burger"
    >
      <div
        class="burger-button hidden-lg-and-up"
        @click="drawer = !drawer"
      >
        <div class="burger-button-line" />
        <div class="burger-button-line mt-5" />
        <div class="burger-button-line mt-5" />
      </div>
      <el-drawer
        :visible.sync="drawer"
        :with-header="false"
        direction="ltr"
        :show-close="false"
        size="300px"
        class="burger-menu-drawer"
      >
        <el-row class="burger-menu-header">
          <el-col :span="8">
            <el-button
              @click="drawer = !drawer"
              class="burger-menu-close-btn"
            >
              <i class="el-icon-arrow-left" />
            </el-button>
          </el-col>
          <el-col :span="12">
            <h2 class="burger-menu-title">
              {{ $t('menu.menu') }}
            </h2>
          </el-col>
        </el-row>
        <el-row class="burger-menu-main">
          <Navigation
            :is-admin="isAdmin"
            :is-business="isBusiness"
            :is-team-resp="isTeamResp"
            :is-employee="isEmployee"
            :has-iban="hasIban"
            :sign-out-dialog.sync="signOutDialogVisible"
            :delete-user-dialog.sync="deleteUserDialogVisible"
            :loader-visible.sync="fullScreenLoading"
            :employee-reconciliation-dialog.sync="employeeReconciliationDialog"
            :drawer.sync="drawer"
          />
        </el-row>
      </el-drawer>
    </div>
    <SignOutDialog
      :visible.sync="signOutDialogVisible"
    />
    <DeleteUserDialog
      :visible.sync="deleteUserDialogVisible"
    />
    <confirm-employee-reconciliation
      :visible.sync="employeeReconciliationDialog"
    />
    <promoting-apps-banner />
  </div>
</template>

<script>
import Navigation from './components/Navigation';
import SignOutDialog from '../Components/SignOutDialog';
import DeleteUserDialog from '../Components/DeleteUserDialog';
import ConfirmEmployeeReconciliation from '../Reconciliation/Components/ConfirmEmployeeReconciliation';
import authHelpers from '@/plugins/auth-helpers.js';
import PromotingAppsBanner from '../Components/PromotingAppsBanner.vue';

export default {
  name: 'Menu',
  components: {
    Navigation,
    SignOutDialog,
    DeleteUserDialog,
    ConfirmEmployeeReconciliation,
    PromotingAppsBanner
  },
  data: () => ({
    fullScreenLoading: false,
    drawer: false,
    signOutDialogVisible: false,
    deleteUserDialogVisible: false,
    employeeReconciliationDialog: false,
    isAdmin: false,
    isBusiness: false,
    isTeamResp: false,
    isEmployee: false,
    hasIban: false
  }),
  created () {
    authHelpers.isCurrentUserAdmin().then((response) => {
      this.isAdmin = response;
    });
    authHelpers.isCurrentUserBusiness().then((response) => {
      this.isBusiness = response;
    });
    authHelpers.isCurrentUserTeamResp().then((response) => {
      this.isTeamResp = response;
    });
    authHelpers.isCurrentUserEmployee().then((response) => {
      this.isEmployee = response;
    });
    authHelpers.isCurrentUserHasIban().then((response) => {
      this.hasIban = response;
    });
  }
};
</script>

<style scoped lang="scss">
.desktop-menu {
  width: 300px;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
